"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// loads data from the backend API into the cabins store
function refreshCabinsAndCabinCategories(_a) {
    var getters = _a.getters, commit = _a.commit, dispatch = _a.dispatch;
    return __awaiter(this, void 0, void 0, function () {
        var code;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch('findCabinCategories')];
                case 1:
                    _b.sent();
                    commit('cabins/REMOVE_LOADED_CABINS');
                    if (!getters['cabins/isPremiumSelected'] && !getters['cabins/isPremiumAISelected']) {
                        // There could be valid premium configs but we would have to reload the cabins
                        // and the user seems to be interested in vario
                        if (!getters['cabins/selectedCabinCategoryIsValid']) {
                            commit('wizard/setStepIncompleted', 'bookingCabinCategory');
                        }
                        commit('cabins/REMOVE_USER_SELECTIONS', 'PREMIUM_CONFIGURATIONS');
                        return [2 /*return*/];
                    }
                    code = getters['cabins/selectedCabinCategoryCode'];
                    if (!code) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch('findCabins', code)
                        // also check that cabin is valid (for the case that cabin gets invalidified but our category is still valid)
                        // if no cabin remove all selections
                    ];
                case 2:
                    _b.sent();
                    // also check that cabin is valid (for the case that cabin gets invalidified but our category is still valid)
                    // if no cabin remove all selections
                    if (getters['cabins/currentSelectionCabin']) {
                        // remove everything except the valid and currently selected one
                        // There could be valid premium configs but we would have to reload the cabins
                        commit('cabins/REMOVE_USER_SELECTIONS', code);
                        return [2 /*return*/];
                    }
                    _b.label = 3;
                case 3:
                    commit('cabins/REMOVE_USER_SELECTIONS');
                    commit('wizard/setStepIncompleted', 'bookingCabinCategory');
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = refreshCabinsAndCabinCategories;
//# sourceMappingURL=refresh_cabins_and_cabin_categories.js.map